module.exports = __webpack_public_path__ + "img/img8.9d04a56e.png";